import axios from 'axios'
import _ from 'lodash'
const preProcessorURI = 'monedero/penalizardesdelonchera/',
	opcionesPenalización = _.map([
		{
			costo: 12,
			text: 'Lonchera sin lavar'
		}, {
			costo: 12,
			text: 'Lonchera no recibida'
		}, {
			costo: 499,
			text: 'Lonchera nueva'
		}, {
			costo: 499,
			text: 'Reposición de lonchera'
		}
	], item => {
		item.value = item.text;
		return item
	}),
	recargoArchetype = {
		cantidad: 0.0,
		concepto: '',
		comentarios: null
	},
	monederoCaptions = [
		{
			"key": "imagen"
		}, {
			"key": "cantidad"
		}, {
			"key": "estatus"
		}, {
			"key": "_"
		}
	]
let preConfigLonchera = async (loncheraId) => {
	return await axios.get(createProcessorURI(loncheraId))
}
let getCostoSugeridoPenalización = (value) => {
	let found = _.find(opcionesPenalización, {value})
	return found.costo
}
let storePenalizacion = async (loncheraId, pData) => {
	return await axios.post(createProcessorURI(loncheraId), pData)
}
// UTILS
function createProcessorURI(loncheraId) {
	return(preProcessorURI + loncheraId)
}
// EXPORTS
export {
	preConfigLonchera,
	storePenalizacion,
	monederoCaptions,
	opcionesPenalización,
	recargoArchetype,
	getCostoSugeridoPenalización
}